//
// Yes/No answers on the 1st page should reset depending on the change in selection
//

var initialPageButtons = (function () {
    'use strict';

    var pathInputsSelector = "[name^='path_']";

    function getSequence() {
        var inputs = $(pathInputsSelector);
        var sequence = new Set();
        inputs.each(function () {
            sequence.add($(this).attr("name"));
        });

        return Array.from(sequence);
    }

    function init() {
        // if some day someone changes the names on the back-end to for example fix the "actibe_abn" typo this will break..
        // var sequence = ["path_business_lending", "path_actibe_abn", "path_business_rely_trade"];
        var sequence = getSequence();

        $(pathInputsSelector).each(function () {
            var input = $(this);
            var parent = $(this).parent();

            parent.click(function (e) {
                if (input.val() == "No") {
                    // reset the next values
                    var passed = false;
                    for (var i = 0; i < sequence.length; i++) {
                        if (passed) {
                            var toUncheckSelector = `[name="${sequence[i]}"]`;
                            $(`${toUncheckSelector}:checked`).parent().removeClass("active");
                            $(toUncheckSelector).prop("checked", false);
                        } else if (sequence[i] == input.attr("name")) {
                            passed = true;
                        }
                    }
                }
            });
        });
    }

    if ($(pathInputsSelector)) {
        init();
    }
})();